import React from 'react'

import { Grid } from 'system'

export const LinkCardList = ({ children, ...props }) => (
  <Grid
    gridTemplateColumns={['1fr', 'repeat(2, 1fr)']}
    gridGap={3}
    my={3}
    {...props}
  >
    {React.Children.map(children, child =>
      React.cloneElement(child, { myScale: 0, maxWidth: 'none' }),
    )}
  </Grid>
)
